<template>
    <div id='contacts'>
        <div class="head">
            <div class="pubw">
                <h2 class="h">聯繫人</h2>
            </div>
        </div>
        <div class="body">
            <div class="pubw">
                <NavMenu/>
                <div class="contactList">
                    <div class="tr">
                        <div class="pubw">
                            <div class="left">
                                <p class="h">聯繫人</p>
                                <p class="h">地址</p>
                            </div>
                            <div class="right">
                                <p class="h">郵政編碼</p>
                            </div>
                        </div>
                    </div>
                    <div class="contactsBox" v-for="item in contactList" :key="item.id">
                        <div class="contact" >
                            <div class="warp">
                                <el-row>
                                    <el-col :span='6'>
                                        <span>{{item.name}}</span>
                                    </el-col>
                                    <el-col :span='14' class="address">
                                        <span>{{item.addressOne}} {{item.addressTwo}} {{item.addressThree}} {{item.address}}</span>
                                    </el-col>
                                    <el-col :span="3">
                                        {{item.code}}
                                    </el-col>
                                    <el-col :span='6'>
                                        <span>{{item.phoneArea}}</span>
                                        <span>{{item.phone}}</span>
                                    </el-col>
                                    <el-col :span='10'>
                                        <span>{{item.city}}</span>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="option">
                            <div class="edit" @click="handlerEditContact(item)">
                                <span class="el-icon-edit-outline"></span>
                            </div>
                            <div class="delete" @click="handleDeleteContact(item.id)">
                                <span class="el-icon-delete-solid"></span>
                            </div>
                        </div>
                    </div>
                    <div class="emptyTips" v-show="contactList.length <= 0">
                        <span>未有聯繫人紀錄。</span>
                    </div>
                    <div class="addContaxt" @click="showAddContaxtDiglog">
                        <div class="increment" >
                            <span class="el-icon-circle-plus"></span>
                        </div>
                        <span>新增聯繫人</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 添加联系人对话框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="showAddContaxt"
            :before-close="handleClose"
            width="1280px"
            :close-on-click-modal="false"
            >
            <div class="contactForm">
                <MailForm ref="MailForm" :isContact="true" :callback="formCallback" :isTrigger="isTrigger" :initTrigger="initTrigger" :contextForm="contextForm"/>
            </div>
            <span class="mydialog-footer">
                <p @click="handleClose">取 消</p>
                <optionsButton title="确定" :callback="()=>{this.isTrigger=true}"/>
            </span>
        </el-dialog>

        <!-- 警告弹出框 -->
        <Alert title="刪除" text="是否確認刪除聯繫人?" :callback="deleteContact" :alertShow="alertShow"/>
    </div>
</template>

<script>
import optionsButton from '@/components/optionButton'
import Alert from '@/components/Alert'
import {nanoid} from "nanoid"
import NavMenu from "@/components/NavMenu.vue"
// 表单组件
import MailForm from "@/components/MailForm.vue"
export default {
    name:'Contacts',
    components:{
        optionsButton,
        Alert,
        MailForm,
        NavMenu
    },
    data(){
        return {
            // 当前对话框的标题
            dialogTitle:"新增連絡人",
            // 联系人列表
            contactList:[
            ],
            // 控制是否展示添加联系人对话框
            showAddContaxt:false,
            // 控制弹出框是否展示
            alertShow:false,
            // 当前要删除联系人的id
            deleteId:'',
            // 控制周份列表是否显示
            ancientShow:true,
            // 是否触发表单的校验
            isTrigger:false,
            // 表单传过来的的ref
            formRef:{},
            contextForm:undefined
        }
    },
    methods: {
        // 获取国家和地区
        async getRegion(){
            let res = await this.$http.get("app/v2/getRegion")
            console.log(res,"国家地区列表")
            if(!res.data.code) return this.$message.error("獲取國家地區失敗")
            this.countryList = res.data.data
        },
        // 获取联系人列表信息
        async getContactList(){
            let res = await this.$http.post("app/v2/getAddress")
            console.log(res,"联系人列表")
            if(!res.data.code) return this.$message.error("獲取連絡人失敗")
            this.contactList = res.data.data
        },
        // 监听用户点击显示添加联系人对话框
        showAddContaxtDiglog(){
            document.getElementById("header").style.opacity = "0"
            document.querySelector("#contacts .head").style.opacity = "0"
            document.querySelector("#contacts .body").style.opacity = "0"
            this.showAddContaxt = true
        },
        // 监听添加联系人对话框关闭
        handleClose(){
            
            const myref = this.$refs.MailForm
            myref.$refs.formRef.resetFields()
            document.getElementById("header").style.opacity = "1"
            document.querySelector("#contacts .head").style.opacity = "1"
            document.querySelector("#contacts .body").style.opacity = "1"
            this.showAddContaxt = false
            this.dialogTitle = '新增連絡人'
            this.getContactList()
        },
           // 表单回调
        formCallback(form,formRef){
            this.actionsFun(form)
        },
         // 恢复表单触发回调的依赖属性
        initTrigger(){
            this.isTrigger = false
        },
        // 添加
        async edit(form){
            let res = await this.$http.post("app/v2/editAddress",{
                    ...form
                })
                if(!res.data.success) return this.$message.error("編輯連絡人失敗")
                this.$message.success("編輯連絡人成功")
                this.handleClose()
        },
        // 编辑
        async add(form){
            let res = await this.$http.post("app/v2/addAddress",{
                ...form
            })
            if(!res.data.success){
                    if(res.data.message) return this.$message.error(res.data.message)
                    return  this.$message.error("添加連絡人失敗")
                }
                this.$message.success("添加連絡人成功")
                this.handleClose()
        },
        // 联系人操作
        async actionsFun(form){
            // 编辑联系人
            if(this.dialogTitle == "編輯連絡人"){
                this.edit(form)
            }// 添加联系人
            else{
                this.add(form)
            }
        },
        // 监听用户点击编辑联系人
        async handlerEditContact(item){
            this.dialogTitle = "編輯連絡人"
            this.showAddContaxt = true
            this.contextForm = item
        },
        // 监听用户点击删除联系人
        handleDeleteContact(id){
            this.alertShow = true
            this.deleteId = id
        },
        // 删除联系人
        async deleteContact(type){
            if(type){
                let res = await this.$http.post("app/v2/removeAddress?userAddressId="+this.deleteId)
                if(!res.data.code) return this.$message.error("删除連絡人失敗")
                this.$message.success("删除連絡人成功")
                this.getContactList()
            }
            return this.alertShow = false
        },
    },
    // 生命周期==>创建完成
    mounted() {
        this.getContactList()
    },
}
</script>

<style lang="less">
    #contacts{
        background-color: #F2F2F2;
        .head{
            background-color: #F2F2F2;
            height: 258px;
            padding-top:130px;
            .h{
                font-weight: 600;
                font-size: 30px;
            }
        }
        .body{
            display: flex;
            justify-content: space-between;
            &>.pubw{
                display: flex;
                justify-content:space-between;
            }
            .contactList{
                width: 75%;

                .tr{
                    height: 56px;
                    border-bottom:2px solid #ccc;
                    font-size:17px;
                    font-weight:590;
                    .pubw{
                        display: flex;
                        align-items:center;
                        height: 100%;
                        .left{
                            display: flex;
                            justify-content: space-around;
                            width: 30%;
                        }
                        .right{
                            display: flex;
                            justify-content: space-around;
                            width: 70%;
                        }
                    }
                }
                min-height: 700px;
                .contactsBox{
                    display: flex;
                    align-items:center;
                    .contact{
                        width: 90%;
                        box-shadow: 0px 2px 8px #ccc;
                        padding:20px 30px 30px;
                        border-radius:10px;
                        margin-top: 20px;
                        .el-row{
                            line-height: 30px;
                            .address{
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipse;
                            }
                            .el-col{
                                span{
                                    margin-right:5px;
                                }
                            }
                        }
                    }
                    .option{
                        display: flex;
                        width: 10%;
                        justify-content: flex-end;
                        .delete,.edit{
                            font-size: 30px;
                            color:@colorMain;
                            margin-left:10px;
                            &:hover{
                                cursor: pointer;
                                opacity: .8;
                            }
                        }
                        .delete{
                            span{
                                color: #F7320F;
                            }
                        }
                    }
                }
                .emptyTips{
                    font-size: 17px;
                    margin-top: 30px;
                    text-align: center;
                }
                .addContaxt{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 100px;
                    margin-bottom: 50px;
                    span{
                        color:@colorMain;
                        font-size:17px;
                        font-weight:550;
                    }
                    .increment{
                        margin-right:8px;
                        span{
                            color:@colorMain;
                            font-size:30px;

                        }
                    }
                    &:hover{
                        cursor: pointer;
                    }
                }
            }

        }
        .contactForm{
            .addContaxt{
                display: flex;
                align-items: center;
                span{
                    color:@colorMain;
                    font-size:17px;
                    font-weight:550;
                }
                .increment{
                    margin-right:8px;
                    span{
                        color:@colorMain;
                        font-size:30px;

                    }
                }
                &:hover{
                    cursor: pointer;
                }
            }
            .el-row{
                flex-wrap: wrap;
                justify-content: space-between;
                .el-form-item__label{
                    width: 100%;
                    text-align:left;
                    font-size:17px;
                    font-weight:580;
                }
                .phone{
                    display: flex;
                    justify-content: space-between;
                    align-items:center;
                    .phoneInput{
                        width: 75%;
                        margin-top: 35px;
                    }
                }
            }
        }
    }
</style>